module.exports = __webpack_public_path__ + "img/0-13.94fe5540.jpg";